import {
  Grid,
  GridProps,
  Checkbox,
  FormControlLabel,
  Typography,
  Box,
} from "@mui/material";
import { useEffect, useState } from "react";

interface LabelCheckboxProps extends GridProps {
  defaultState?: boolean;
  boxLabel?: string;
  value?: string | number;
  onSelected?: (value?: string | number, label?: string) => void;
}

function LabelCheckbox({
  defaultState,
  value,
  boxLabel,
  onSelected,
  ...rest
}: LabelCheckboxProps) {
  const [selected, setSelected] = useState<boolean>(defaultState || false);

  const handleChipSelected = (e: any) => {
    // e.stopPropagation();
    // console.log(e)
    const prev = selected;
    setSelected(!prev);
    if (onSelected) {
      onSelected(value, boxLabel);
    }
  };

  useEffect(() => setSelected(defaultState || false), [defaultState]);

  return (
    <Grid
      onClick={handleChipSelected}
      {...rest}
      display="flex"
      alignItems="center"
    >
      <Checkbox checked={selected} />
      <Typography
        onClick={(e: any) => {
          // e.stopPropagation();
        }}
      >
        {boxLabel}
      </Typography>
    </Grid>
  );
}

export default LabelCheckbox;
